function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Fill 1");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Frame",
  transform: "translate(-340.000000, -20.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(329.000000, 12.000000)"
}, React.createElement("path", {
  d: "M18.7189441,8.24408897 C18.5487884,8.08787536 18.31749,8 18.0773209,8 C17.836267,8 17.6049686,8.08787119 17.4348129,8.24408897 L11.265874,13.9036038 C11.0957183,14.0598174 11,14.2713514 11,14.492654 C11,14.7139566 11.0957137,14.9254907 11.265874,15.0817043 L17.4348129,20.7412191 C17.6031967,20.9039416 17.8371518,20.9975135 18.0817676,20.9999505 C18.3263608,21.0023916 18.5621059,20.9145204 18.734916,20.7550492 C18.9077307,20.5963945 19.0034445,20.3799699 18.9999052,20.1554181 C18.996366,19.9308662 18.894445,19.7168744 18.7171972,19.5622854 L13.1898587,14.4926332 L18.7171972,9.42298098 C18.8873529,9.26676737 18.983956,9.05523332 18.983956,8.83393071 C18.984843,8.6126281 18.8891293,8.40028174 18.7189668,8.24406814 L18.7189441,8.24408897 Z",
  id: "Fill-1"
}))));

var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "8px",
    height: "13px",
    viewBox: "0 0 8 13",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left.6a9c0164.svg";
export { ForwardRef as ReactComponent };